const createLivewireHtmlForm = () => ({
    syncing: false,
    init() {
        const form = this.$el.closest("form");
        const pending = new Set();

        // Livewire 4's commit.fail hook does not run for network failures.
        // interceptMessage onFinish does (success, error, cancel, and dropped requests).
        const stop = Livewire.interceptMessage(({ message, onFinish }) => {
            if (!this.isNestedCommit(message?.component)) {
                return;
            }

            pending.add(message);
            this.syncing = true;

            onFinish(() => {
                pending.delete(message);
                this.syncing = pending.size > 0;
            });
        });

        this._stopIntercept = typeof stop === "function" ? stop : null;

        form?.addEventListener("submit", (event) => {
            if (this.syncing) {
                event.preventDefault();
            }
        });
    },
    destroy() {
        this._stopIntercept?.();
    },
    isNestedCommit(component) {
        const componentEl = component?.el;

        if (!(componentEl instanceof HTMLElement)) {
            return false;
        }

        if (this.$el === componentEl || this.$el.contains(componentEl)) {
            return true;
        }

        const owner = this.$el.closest("[wire\\:id]");

        return owner instanceof HTMLElement && owner === componentEl;
    },
});

export const registerLivewireHtmlForm = (Alpine) => {
    // Page drawers teleport this island to body. Alpine then evaluates x-data as a
    // JS expression, not an Alpine.data() lookup, so expose the factory on window.
    window.livewireHtmlForm = createLivewireHtmlForm;
    Alpine.data("livewireHtmlForm", createLivewireHtmlForm);
};
